import { render, staticRenderFns } from "./platformChat.vue?vue&type=template&id=c48ab932&scoped=true"
import script from "./platformChat.vue?vue&type=script&lang=js"
export * from "./platformChat.vue?vue&type=script&lang=js"
import style0 from "./platformChat.vue?vue&type=style&index=0&id=c48ab932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48ab932",
  null
  
)

export default component.exports